import { sendEmailVerification } from "firebase/auth";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { useState } from "react";
import { UserAuth } from "../context/AuthContext";
import Iconify from "../components/Iconify";


const VerifyEmail = () => {
    const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);
  const { user, signUp, signUpSecondStep } = UserAuth();

  const handleResend = async () => {
    if (!user || user.emailVerified) return;
    setLoading(true);
    await sendEmailVerification(user);
    setResent(true);
    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        px: 3,
        bgcolor: "#fff"
      }}
    >
      <Box
        sx={{
          maxWidth: 480,
          width: "100%",
          p: 4,
          bgcolor: "#fff",
          borderRadius: 4,
          boxShadow: 3,
          textAlign: "center"
        }}
      >
       
        <Iconify icon={'mdi-light:email'} sx={{ fontSize: 60, color: "#3f51b5", mb: 2 }}/>
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Vérifie ton adresse email
        </Typography>

        <Typography sx={{ color: "text.secondary", mb: 2 }}>
          Nous t'avons envoyé un lien de vérification à :
        </Typography>
        <Typography sx={{ fontWeight: 500, mb: 2 }}>{user?.email}</Typography>

        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Clique sur le lien reçu pour activer ton compte.
        </Typography>

        {resent && (
          <Alert severity="success" sx={{ mt: 3 }}>
            Le lien a été renvoyé avec succès.
          </Alert>
        )}

        <Button
          variant="outlined"
          size="large"
          onClick={handleResend}
          sx={{ mt: 4 }}
          disabled={loading || resent}
        >
          {loading ? <CircularProgress size={24} /> : "Renvoyer le lien"}
        </Button>
      </Box>

      <Typography variant="caption" sx={{ mt: 4, color: "text.disabled" }}>
        © {new Date().getFullYear()} Choptonticket
      </Typography>
    </Box>
  );
};

export default VerifyEmail;
